import { TableHeadersType } from '../tableHeadersType';

export const ACCOUNTS_MANAGER_HEADERS: TableHeadersType[] = [
  {
    "label": "Accounts Name",
    "value": "ledger_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Account Number",
    "value": "ledger_number",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Account Type",
    "value": "ledger_type",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Parent Account",
    "value": "parentAccount",
    "defaultChecked": true,
    "checked": true
  },

  {
    "label": "Status",
    "value": "status",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "ADDED/MODIFIED BY",
    "value": "updated_by",
    "defaultChecked": true,
    "checked": true
  },
]